// removed by extract-text-webpack-plugin
module.exports = {"yx_yxCircle_sm":"yx_yxCircle_sm___2v2jT","fontSize_1":"fontSize_1___2RAou","fontSize_2":"fontSize_2___B3l3j","fontSize_3":"fontSize_3___3WcT9","fontSize_4":"fontSize_4___2BOxH","fontSize_5":"fontSize_5___3CL56","fontSize_6":"fontSize_6___YSpCO","fontColor_1":"fontColor_1___3Dz0Q","fontColor_2":"fontColor_2___Ux6y-","fontColor_3":"fontColor_3___i_CMS","fontColor_4":"fontColor_4___376h-","fontColor_5":"fontColor_5___3RNN3","fontColor_6":"fontColor_6___4Z0jN","select":"select___fwyFU"};


//////////////////
// WEBPACK FOOTER
// ./src/widget/HeaderNav/HeadreNavView.less
// module id = ./src/widget/HeaderNav/HeadreNavView.less
// module chunks = 43